import { InputItem, List, WhiteSpace, Button, Toast } from "antd-mobile-v2";
import React, { Component } from "react";
import { createForm } from "rc-form";
import "./index.less";
import { get, post } from "../../../api/service/services";
import allUrl from "../../../api/allUrl";
import tool from "../../../api/tool";
import sectioValue from "../../../api/service/secsstion";
import {sm4} from "sm-crypto";
import publicKey from "../../../constants/publicKey";

const Item = List.Item;
class ConfimPaswed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "forget",
    };
  }
  componentDidMount() {
    this.getuserInfoData();
  }
  // 获取用户信息
  getuserInfoData = async () => {
    let userCode = sectioValue.get("acount");
    if (!userCode) {
      this.setState({ type: "forget" });
      return;
    }
    this.setState({ type: "edit" });
  };

  // 密码和确认密码
  compareToFirstPassword = (rule, value, callback) => {
    if (value && value !== this.props.form.getFieldValue("newPassWord")) {
      callback("您输入的密码不一致");
    } else {
      callback();
    }
  };
  // 数据提交
  onSubmit = () => {
    const { type } = this.state;
    this.props.form.validateFields({ force: true }, (error, values) => {
      if (error) {
        let errorData = Object.keys(error)[0];
        Toast.info(error[errorData].errors[0].message, 1);
        return;
      }
      if (type == "edit") {
        values["userCode"] = sectioValue.get("acount") || "";
      }
      this.requestSubmit(values);
    });
  };
  // 新密码提交数据
  requestSubmit = (values) => {
    let tolData = tool.get("validation");
    let newData = Object.assign(tolData && tolData.data, values);
    newData.newPassWordVerify=sm4.encrypt(newData.newPassWordVerify,publicKey)
    newData.newPassWord=sm4.encrypt(newData.newPassWord,publicKey)
    post(
      this.state.type === "edit"
        ? allUrl.register.editPasswed
        : allUrl.register.uploadePaswed,
      newData,
      {
        "Content-Type": "application/json;charset=UTF-8",
        "Captcha-SMS-Code":
          newData && newData.phoneCode ? newData.phoneCode : "",
      }
    )
      .then((res) => {
        if (res.code === 200 && res.success === true) {
          Toast.success("密码修改成功", 1, () => {
            sectioValue.remove("token");
            sectioValue.remove("acount");
            sectioValue.remove("user_id");
            sectioValue.remove("nick_name");
            sectioValue.remove("tokenTime");
            sectioValue.remove("refstoken");
            this.props.props.history.push("/home");
            tool.remove("userInfoData");
          });
        } else {
          Toast.info(res.msg, 1);
        }
      })
      .catch((err) => {
        Toast.info(err.data && err.data.msg ? err.data.msg : "请求出错", 1);
      });
  };
  render() {
    const { getFieldProps, getFieldError } = this.props.form;
    const { flagCode, count } = this.state;
    return (
      <div className="confim-Passwed">
        <form>
          <InputItem
            {...getFieldProps("newPassWord", {
              // initialValue: 'little ant',
              rules: [
                { required: true, message: "请输入新密码" },
                {
                  required: false,
                  pattern: new RegExp(
                    /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
                    "g"
                  ),
                  message: "请输入正确的密码",
                },
              ],
            })}
            clear
            type="password"
            error={!!getFieldError("newPassWord")}
            placeholder="请输入新密码"
          >
            <span style={{ color: "red" }}>*</span> 新密码
          </InputItem>
          <InputItem
            {...getFieldProps("newPassWordVerify", {
              // initialValue: 'little ant',
              rules: [
                { required: true, message: "请再次输入密码" },
                {
                  validator: this.compareToFirstPassword,
                },
              ],
            })}
            clear
            type="password"
            error={!!getFieldError("newPassWordVerify")}
            placeholder="请再次输入新密码"
          >
            <span style={{ color: "red" }}>*</span> 确认密码
          </InputItem>
          <WhiteSpace />
          <WhiteSpace />
          <WhiteSpace />
          <Item>
            <Button type="primary" onClick={this.onSubmit}>
              提交
            </Button>
          </Item>
        </form>
      </div>
    );
  }
}

export default createForm()(ConfimPaswed);
